var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedphone36Px(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2796 18.714C29.4581 19.9526 29.5753 21.6468 29.0196 22.2953C28.1011 23.3681 22.2856 23.3681 22.2856 21.2225C22.2856 20.1426 23.2427 19.434 22.3242 18.3612C21.4213 17.307 19.8014 17.2898 18.0001 17.2884C16.1987 17.287 14.5802 17.3055 13.676 18.3612C12.7574 19.434 13.7145 20.1426 13.7145 21.2225C13.7145 23.3667 7.89906 23.3667 6.98053 22.2953C6.42484 21.6468 6.54198 19.9526 6.72054 18.714C6.85768 17.8869 7.20481 16.9955 8.31762 15.857C9.98612 14.2999 12.5103 13.0286 17.9115 13H18.0915C23.4927 13.0271 26.0169 14.2999 27.6854 15.857C28.7967 16.9955 29.1453 17.8869 29.2824 18.714H29.2796Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedphone36Px);
export default __webpack_public_path__ + "static/media/redphone36px.11c2e9df65d9278398f2e77d68d80fa7.svg";
export { ForwardRef as ReactComponent };